import Navigation from "../components/navigation";
import Footer from "../components/footer";
import HeadingTitle from "../pkg/components/heading-title";
import { companyName, navigation } from "../config/constants";
import Header from "../components/header";
import Main from "../pkg/components/main";
import LeadParagraph from "../pkg/components/lead-paragraph";

function Opteron() {
	return (
		<>
			<Navigation companyName={companyName} navigation={navigation} />

			<Main>
				<Header>Opteron</Header>

				<HeadingTitle>Closed-Loop Operations</HeadingTitle>

				<LeadParagraph>
					Deployment is just the first move. Every system observes itself. Telemetry, user interaction, failure states — they flow into a 
                    monitoring layer that feeds back into the ontology. When the business shifts, the system responds. New insights trigger dynamic 
                    updates to logic. Entire workflows evolve autonomously. No tickets. No silos. Just systems that get better—continuously, and at scale.
				</LeadParagraph>
			</Main>

			<Footer />
		</>
	);
}

export default Opteron;
